import {useDebouncedValue} from "@mantine/hooks";
import {useQuery} from "@tanstack/react-query";

const TYPEAHEAD_API =
  "https://typeahead.waow.tech/xrpc/app.bsky.actor.searchActorsTypeahead";
const MIN_CHARS = 3;

interface SearchActorsTypeaheadResponse {
  actors: {
    did: string;
    handle: string;
    labels: never[];
    avatar?: string;
    createdAt?: string;
    displayName?: string;
  }[];
}

export function useHandleTypeaheadQuery(query: string) {
  const [debouncedValue] = useDebouncedValue(query, 250);

  return useQuery({
    queryKey: ["handle-typeahead", debouncedValue],
    queryFn: (): Promise<SearchActorsTypeaheadResponse> => {
      const url = new URL(TYPEAHEAD_API);
      url.searchParams.set("term", debouncedValue);
      url.searchParams.set("limit", "1");

      return window.fetch(url).then(response => {
        if (!response.ok) {
          throw new Error(`Typeahead API error: ${response.status}`);
        }
        return response.json();
      });
    },
    enabled: debouncedValue.length >= MIN_CHARS,
    staleTime: 1000 * 60,
  });
}
